import { useEffect, useState } from 'react';
import config from '../config';

const filterWhereDisplayTrue = ['==', 'display', true];

export default function useAssetLayer({ stateSchema }) {
  // const [hybridNominalAssetsLayer, setHybridNominalAssetsLayer] =
  //   useState(null);
  // const [hybridActionAssetsLayer, setHybridActionAssetsLayer] =
  //   useState(null);
  // const [hybridMinorAssetsLayer, setHybridMinorAssetsLayer] =
  //   useState(null);
  // const [hybridModerateAssetsLayer, setHybridModerateAssetsLayer] =
  //   useState(null);
  // const [hybridMajorAssetsLayer, setHybridMajorAssetsLayer] =
  //   useState(null);

  const [hybridLayersLoaded, setHybridLayersLoaded] = useState(false);

  const [hybridLayers, setHybridLayers] = useState([
    null,
    null,
    null,
    null,
    null
  ]);

  //  No Flooding Layer
  useEffect(() => {
    setHybridLayersLoaded(false);

    const hybridNominalAssetsLayer = {
      name: 'hybrid_nominal',
      sourceInfo: {
        type: 'vector',
        tiles: [config.stateAssetsTileService(stateSchema, 'hybrid_nominal')],
        minzoom: 0,
        maxzoom: 22
      },
      layerInfo: {
        id: 'hybrid_nominal',
        source: 'hybrid_nominal',
        'source-layer': `${stateSchema}.hybrid_nominal`,
        type: 'circle',
        paint: {
          'circle-radius': 5,
          'circle-color': config.darkPlotColors.colorNominal,
          'circle-stroke-color': 'gray',
          'circle-stroke-width': 1,
          'circle-opacity': 1.0
        },
        filter: filterWhereDisplayTrue
      }
    };
    // setHybridNominalAssetsLayer(hybridNominalAssetsLayer);

    //  Action Layer
    const hybridActionAssetsLayer = {
      name: 'hybrid_action',
      sourceInfo: {
        type: 'vector',
        tiles: [config.stateAssetsTileService(stateSchema, 'hybrid_action')],
        minzoom: 0,
        maxzoom: 22
      },
      layerInfo: {
        id: 'hybrid_action',
        source: 'hybrid_action',
        'source-layer': `${stateSchema}.hybrid_action`,
        type: 'circle',
        paint: {
          'circle-radius': 5,
          'circle-color': config.darkPlotColors.colorAction,
          'circle-stroke-color': 'gray',
          'circle-stroke-width': 1,
          'circle-opacity': 1.0
        },
        filter: filterWhereDisplayTrue
      }
    };
    // setHybridActionAssetsLayer(hybridActionAssetsLayer);

    //  Minor Layer
    const hybridMinorAssetsLayer = {
      name: 'hybrid_minor',
      sourceInfo: {
        type: 'vector',
        tiles: [config.stateAssetsTileService(stateSchema, 'hybrid_minor')],
        minzoom: 0,
        maxzoom: 22
      },
      layerInfo: {
        id: 'hybrid_minor',
        source: 'hybrid_minor',
        'source-layer': `${stateSchema}.hybrid_minor`,
        type: 'circle',
        paint: {
          'circle-radius': 5,
          'circle-color': config.darkPlotColors.colorMinor,
          'circle-stroke-color': 'gray',
          'circle-stroke-width': 1,
          'circle-opacity': 1.0
        },
        filter: filterWhereDisplayTrue
      }
    };
    // setHybridMinorAssetsLayer(hybridMinorAssetsLayer);

    //  moderate Layer
    const hybridModerateAssetsLayer = {
      name: 'hybrid_moderate',
      sourceInfo: {
        type: 'vector',
        tiles: [config.stateAssetsTileService(stateSchema, 'hybrid_moderate')],
        minzoom: 0,
        maxzoom: 22
      },
      layerInfo: {
        id: 'hybrid_moderate',
        source: 'hybrid_moderate',
        'source-layer': `${stateSchema}.hybrid_moderate`,
        type: 'circle',
        paint: {
          'circle-radius': 5,
          'circle-color': config.darkPlotColors.colorModerate,
          'circle-stroke-color': 'gray',
          'circle-stroke-width': 1,
          'circle-opacity': 1.0
        },
        filter: filterWhereDisplayTrue
      }
    };

    // setHybridModerateAssetsLayer(hybridModerateAssetsLayer);

    //  major Layer
    const hybridMajorAssetsLayer = {
      name: 'hybrid_major',
      sourceInfo: {
        type: 'vector',
        tiles: [config.stateAssetsTileService(stateSchema, 'hybrid_major')],
        minzoom: 0,
        maxzoom: 22
      },
      layerInfo: {
        id: 'hybrid_major',
        source: 'hybrid_major',
        'source-layer': `${stateSchema}.hybrid_major`,
        type: 'circle',
        paint: {
          'circle-radius': 5,
          'circle-color': config.darkPlotColors.colorMajor,
          'circle-stroke-color': 'gray',
          'circle-stroke-width': 1,
          'circle-opacity': 1.0
        },
        filter: filterWhereDisplayTrue
      }
    };
    // setHybridMajorAssetsLayer(hybridMajorAssetsLayer);

    setHybridLayers([
      hybridNominalAssetsLayer,
      hybridActionAssetsLayer,
      hybridMinorAssetsLayer,
      hybridModerateAssetsLayer,
      hybridMajorAssetsLayer
    ]);

    setHybridLayersLoaded(true);
  }, [stateSchema]);

  // useEffect(() => {
  //   if (hybridLayersLoaded) {
  //     setHybridLayers([
  //       hybridNominalAssetsLayer,
  //       hybridActionAssetsLayer,
  //       hybridMinorAssetsLayer,
  //       hybridModerateAssetsLayer,
  //       hybridMajorAssetsLayer,
  //     ]);
  //   }
  // }, [hybridLayersLoaded]);

  return { hybridLayers, hybridLayersLoaded };
}
